export default __webpack_public_path__ + "static/media/location icon.59f5bd93.svg";